
const Korea = {
    "form.isRequired": "{name} 입력은 필수 입니다!",
    "form.OTPLabel": "이메일 인증 코드",
    "form.OTPInputValidMessage": "성공",
    "form.OTPInputInvalidMessage": "잘못된 인증 코드 입니다.",
    "form.OTPWaitSecondsLabel": "다시 보내기 ({waitOtpSeconds}s)",
    "form.OTPSendLabel": "인증 코드 보내기",
    "form.OTPSendSuccessLabel": "인증 코드가 이메일로 성공적으로 발송 되었습니다!",
    "form.OTPTips": "유효한 인증 코드를 입력해 주세요.",
    "form.selectInputLabel": "검색…",
    "form.uploadBtn": "업로드",
    "form.uploadSizeTips": "파일은 5MB 이하만 업로드 가능합니다.",
    "form.uploadTypeTips": "허용되는 파일 형식 : PNG, GIF, JPG, JPEG, PDF",
    "form.uploadNumTips": "파일을 업로드 해야 합니다.",
    "form.isRequiredAccept": "계속 진행하려면 동의가 필요합니다.",
    "form.sendButton": "보내기",
    "form.isEmail": "유효한 이메일 주소를 입력해 주세요.",
    "form.isSerialNumber": "{name}에 13자를 입력해 주세요.",
    "form.categoryPlaceholder": "제품 카탈로그 선택",
    "form.seriesPlaceholder": "제품 시리즈 선택",
    "form.skuPlaceholder": "모델 번호 (SKU)",
    "form.sendSuccessMsg": "전송 성공",

    "warrantyPeriod.checkTitle": "Check Warranty Period",
    "warrantyPeriod.checkDescription": "Please enter your email and serial number to check the warranty period.",
    "warrantyPeriod.emailLabel": "Email",
    "warrantyPeriod.emailPlaceholder": "Enter Email",
    "warrantyPeriod.serialNumberLabel": "Serial Number",
    "warrantyPeriod.serialNumberPlaceholder": "Enter Serial Number",
    "warrantyPeriod.checkButton": "Check",
    "warrantyPeriod.sendSuccessfulLabel": "Send Successfully! please check your email",
    "warrantyPeriod.checkNoRecordLabel": "Sorry, no record was found!",
}
export {
    Korea
}   